export const ApolloIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10.7707 2.03812L10.7732 7.85966C10.7735 8.77935 9.80642 9.369 9.00285 8.93896L3.23438 5.85226C3.67431 5.1197 4.22755 4.4647 4.86893 3.9112L9.3931 8.14153C9.63284 8.36563 10.0107 8.12266 9.91196 7.80795L8.15747 2.21816C8.74805 2.07579 9.364 2 9.99749 2C10.2584 2 10.5162 2.01312 10.7707 2.03812Z"
        fill="#F8FF2C"
      />
      <path
        d="M9.20565 17.9601L9.20313 12.168C9.20277 11.2483 10.1699 10.6586 10.9735 11.0886L16.7441 14.1765C16.3011 14.9071 15.7453 15.5599 15.1014 16.1109L10.5832 11.886C10.3435 11.6619 9.96559 11.9049 10.0644 12.2196L11.8122 17.7883C11.2299 17.9266 10.6227 18 9.99863 18C9.73103 18 9.46643 17.9865 9.20565 17.9601Z"
        fill="#F8FF2C"
      />
      <path
        d="M11.844 9.41101L16.0339 4.82466C15.4872 4.1732 14.8397 3.61119 14.1152 3.16406L11.0557 9.01616C10.6306 9.82915 11.2136 10.8077 12.1226 10.8072L17.871 10.8047C17.8972 10.5396 17.9108 10.2708 17.9108 9.9987C17.9108 9.36605 17.8379 8.75068 17.7007 8.16038L12.1737 9.93594C11.8627 10.0359 11.6225 9.65354 11.844 9.41101Z"
        fill="#F8FF2C"
      />
      <path
        d="M2.13108 9.22131L7.86203 9.21875C8.77118 9.2184 9.35401 10.1969 8.92899 11.0098L5.88524 16.8318C5.16351 16.3857 4.51819 15.8258 3.9732 15.1769L8.14075 10.615C8.36225 10.3725 8.12202 9.99015 7.81096 10.09L2.30859 11.8577C2.1684 11.2615 2.09375 10.6395 2.09375 9.99974C2.09375 9.73705 2.10663 9.47742 2.13108 9.22131Z"
        fill="#F8FF2C"
      />
    </svg>
  );
};
